import { devSimulatePing } from '~/rage/decorators';
import { Subject } from '~/rage/utils';
import {
	CaseItemRarity,
	CasesBundleClientConfig,
	CasesLootboxClientConfig,
	CasesTagConfig,
	CaseType,
	ClientError,
	ClientErrorCode,
	IClientConfigs,
	numWord,
	ParseRewardValueTypeMap,
	RewardType,
	WalletType,
} from '~/shared';
import { ICaseFeedItem, ICasesService } from './casesServiceTypes';

export class CasesServiceStub implements ICasesService {
	private readonly CASE_FEED_MAX_ITEMS = 20;
	private lootboxes = new Subject<CasesLootboxClientConfig[]>([
		{
			id: 'bronze_case',
			donateItemId: 'bronze_case',
			icon: 'bronze_case',
			name: 'Кейс разработчика',
			price: 999999,
			walletType: WalletType.Donate,
			discount: 0.9,
			discountTimestampStart: Date.now() + 1000 * 60 * 60 * 24 * 7,
			discountTimestampEnd: Date.now() + 1000 * 60 * 60 * 24 * 14,
			enabledTimestampStart: Date.now() + 1000 * 60 * 60 * 24 * 14,
			enabledTimestampEnd: Date.now() + 1000 * 60 * 60 * 24 * 14,
			showOnHome: true,
			showOnBanner: true,
			tags: ['tag_new'],
			backgroundColor: '#FF0404',
			// @TODO Для баннера нужно добавить текстовое описание
			// @TODO Для баннера нужно добавить дополнительный заголовок на фон
			items: [
				{
					donateItemId: 'exp100',
					lootboxId: 'bronze_case',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'money10000',
					lootboxId: 'bronze_case',
					rarity: CaseItemRarity.UNCOMMON,
				},
				{
					donateItemId: 'money50000',
					lootboxId: 'bronze_case',
					rarity: CaseItemRarity.RARE,
				},
				{
					donateItemId: 'bugatti_veyron',
					lootboxId: 'bronze_case',
					rarity: CaseItemRarity.EPIC,
				},
				{
					donateItemId: 'bronze_case',
					lootboxId: 'bronze_case',
					rarity: CaseItemRarity.EPIC,
				},
			],
		},
		{
			id: 'case_donater',
			donateItemId: 'case_donater',
			icon: 'case_donater',
			name: 'Донатский кейс',
			price: 94,
			walletType: WalletType.Donate,
			discount: 0.1,
			discountTimestampStart: Date.now() + 1000 * 60 * 60 * 5,
			discountTimestampEnd: Date.now() + 1000 * 60 * 60 * 10,
			enabledTimestampStart: Date.now() + 1000 * 60 * 60 * 5,
			enabledTimestampEnd: Date.now() + 1000 * 60 * 60 * 5,
			showOnHome: true,
			showOnBanner: true,
			tags: ['tag_discount', 'tag_custom', 'tag_new'],
			backgroundColor: '#FFB500',
			items: [
				{
					donateItemId: 'bugatti_veyron',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.EPIC,
				},
				{
					donateItemId: 'lamborghini_urus',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.LEGENDARY,
				},
				{
					donateItemId: 'audi_rs5',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'gaz_2410',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.RARE,
				},
				{
					donateItemId: 'e63s',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.EPIC,
				},
				{
					donateItemId: 'ccl_m_1508',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'ccl_m_1509',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'ccl_m_1510',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'ccl_m_1511',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'ccl_m_1512',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'ccl_m_1513',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'axe',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'beer',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'catfish',
					lootboxId: 'case_donater',
					rarity: CaseItemRarity.COMMON,
				},
			],
		},
	]);
	private caseFeed = new Subject<ICaseFeedItem[]>([]);

	private bundles = new Subject<CasesBundleClientConfig[]>([
		{
			id: 'kit_test',
			icon: 'kit_test',
			name: 'Набор новичка',
			price: 5000,
			discount: 0.1,
			walletType: WalletType.Cash,
			discountTimestampEnd: null,
			discountTimestampStart: null,
			enabledTimestampStart: null,
			enabledTimestampEnd: null,
			showOnBanner: true,
			showOnHome: true,
			tags: [],
			items: [
				{
					donateItemId: 'money50000',
					bundleId: 'set_newbie',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'ford_raptor',
					bundleId: 'set_newbie',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'exp100',
					bundleId: 'set_newbie',
					rarity: CaseItemRarity.COMMON,
				},
				{
					donateItemId: 'bronze_case',
					bundleId: 'set_newbie',
					rarity: CaseItemRarity.COMMON,
				},
			],
		},
	]);

	private caseTags = new Subject<CasesTagConfig[]>([
		{
			id: 'tag_new',
			text: 'Новинка',
			bgColorNormal: '#FF0000',
			textColorNormal: '#FFFFFF',
		} as CasesTagConfig,
		{
			id: 'tag_custom',
			text: 'КАСТОМНЫЙ ТЕГ',
			bgColorNormal: '#FFAA00',
			textColorNormal: '#FFFFFF',
		} as CasesTagConfig,
		{
			id: 'tag_discount',
			text: 'Скидка',
			bgColorNormal: '#FFAA00',
			textColorNormal: '#FFFFFF',
		} as CasesTagConfig,
	]);

	private donateItems = new Subject<IClientConfigs['donate']['inventoryItems']>(
		[
			{
				itemId: 'exp100',
				rewardType: RewardType.EXP,
				rewardValue: 100,
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'money10000',
				rewardType: RewardType.MONEY,
				rewardValue: 10000,
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'money50000',
				rewardType: RewardType.MONEY,
				rewardValue: 50000,
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'bugatti_veyron',
				rewardType: RewardType.VEHICLE,
				rewardValue: 'bugatti_veyron',
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'bmw_7e38',
				rewardType: RewardType.VEHICLE,
				rewardValue: 'bmw_7e38',
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'ccl_m_1509',
				rewardType: RewardType.ITEM,
				rewardValue: 'ccl_m_1509',
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'catfish',
				rewardType: RewardType.ITEM,
				rewardValue: 'catfish',
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'pickaxe',
				rewardType: RewardType.ITEM,
				rewardValue: 'pickaxe',
				sellAmount: null,
				sellIsDonate: null,
			},
			{
				itemId: 'bronze_case',
				rewardType: RewardType.LOOTBOX,
				rewardValue: 'bronze_case',
				sellAmount: null,
				sellIsDonate: null,
			},
		],
	);

	constructor() {
		setInterval(() => {
			const id = `${Date.now()}_${Math.random().toString(16).slice(2)}`;
			const nextItem: ICaseFeedItem = {
				id,
				lootboxId: 'bronze_case',
				rewardId: 'pickaxe',
				rarity: CaseItemRarity.RARE,
			};
			this.caseFeed.next(
				[nextItem, ...this.caseFeed.getValue()].slice(
					0,
					this.CASE_FEED_MAX_ITEMS,
				),
			);
		}, 1000);
	}

	public getLootboxes(): Subject<CasesLootboxClientConfig[]> {
		return this.lootboxes;
	}

	public getBundles(): Subject<CasesBundleClientConfig[]> {
		return this.bundles;
	}

	public getLootboxById(id: string): CasesLootboxClientConfig {
		const item = this.lootboxes.getValue().find((x) => x.id === id);
		if (!item) {
			throw new ClientError(ClientErrorCode.CasesLootboxNotFound);
		}
		return item;
	}

	public getBundleById(id: string): CasesBundleClientConfig {
		const item = this.bundles.getValue().find((x) => x.id === id);
		if (!item) {
			throw new ClientError(ClientErrorCode.CasesBundleNotFound);
		}
		return item;
	}

	public async buyLootbox(
		lootboxId: string,
		count?: number | undefined,
	): Promise<void> {
		// @TODO Логика покупки кейса
		console.log('buyLootbox', { lootboxId, count });
	}

	public async buyBundle(bundleId: string): Promise<void> {
		// @TODO Логика покупки набора
		console.log('buyBundle', { bundleId });
	}

	@devSimulatePing()
	public async openLootbox(id: string): Promise<string> {
		const lootbox = this.lootboxes.getValue().find((x) => x.id === id);
		if (!lootbox) {
			throw new ClientError(ClientErrorCode.CasesLootboxNotFound);
		}

		console.log('openLootbox', { id });

		const items = lootbox.items ?? [];
		const randomItem = items[Math.floor(Math.random() * items.length)];
		return randomItem?.donateItemId ?? items[0]?.donateItemId ?? '';
	}

	public getCaseTypeById(id: string): CaseType {
		const lootbox = this.lootboxes.getValue().find((x) => x.id === id);
		if (lootbox) {
			return CaseType.CASE;
		}
		const bundle = this.bundles.getValue().find((x) => x.id === id);
		if (bundle) {
			return CaseType.SET;
		}
		throw new ClientError(ClientErrorCode.CasesLootboxNotFound);
	}

	public getCaseTags(): Subject<CasesTagConfig[]> {
		return this.caseTags;
	}

	public getCaseTagById(id: string): CasesTagConfig | null {
		const item = this.caseTags.getValue().find((x) => x.id === id);
		return item ?? null;
	}

	public getRewardById(id: string): {
		type: RewardType;
		value: ParseRewardValueTypeMap[RewardType] | null;
	} {
		const item = this.donateItems.getValue().find((x) => x.itemId === id);
		if (!item) {
			return { type: RewardType.ITEM, value: null };
		}
		return {
			type: item.rewardType,
			value: item.rewardValue as ParseRewardValueTypeMap[RewardType],
		};
	}

	public getRewardNameById(id: string): string {
		const { type, value } = this.getRewardById(id);

		if (type === RewardType.VEHICLE) {
			return 'Lamborgini Urus';
		}
		if (type === RewardType.ITEM) {
			return 'Catfish';
		}
		if (type === RewardType.EXP) {
			const amount = (value as ParseRewardValueTypeMap[RewardType.EXP]) ?? 0;
			return `${amount.toLocaleString('ru-RU')} ед. опыта`;
		}
		if (type === RewardType.MONEY) {
			const amount = (value as ParseRewardValueTypeMap[RewardType.MONEY]) ?? 0;
			return `${amount.toLocaleString('ru-RU')} ${numWord(amount, [
				'рубль',
				'рубля',
				'рублей',
			])}`;
		}
		if (type === RewardType.LOOTBOX) {
			const lootbox = this.lootboxes.getValue().find((x) => x.id === value);
			if (lootbox) {
				return `Кейс ${lootbox.name}`;
			}
			return 'Кейс';
		}
		if (type === RewardType.BUNDLE) {
			const bundle = this.bundles.getValue().find((x) => x.id === value);
			if (bundle) {
				return `Набор ${bundle.name}`;
			}
			return 'Набор';
		}

		return '';
	}

	public getRewardImageId(id: string): string | null {
		const { type, value } = this.getRewardById(id);

		if (!value) {
			return id;
		}

		if (type === RewardType.VEHICLE) {
			return value as unknown as string;
		}

		if (type === RewardType.ITEM) {
			return value as unknown as string;
		}

		if (type === RewardType.LOOTBOX) {
			const lootboxId = value as unknown as string;

			const lootboxById = this.lootboxes
				.getValue()
				.find((x) => x.id === lootboxId);
			if (lootboxById?.id) {
				return lootboxById.id;
			}

			const lootboxByDonateId = this.lootboxes
				.getValue()
				.find((x) => x.donateItemId === lootboxId);
			return lootboxByDonateId?.id ?? lootboxId;
		}

		if (type === RewardType.BUNDLE) {
			return value as unknown as string;
		}

		return id;
	}

	public getGroupedLootboxItems(lootboxId: string): Array<{
		type: RewardType;
		ids: string[];
		rarity?: CaseItemRarity;
	}> {
		const lootbox = this.getLootboxById(lootboxId);
		if (!lootbox.items) {
			return [];
		}

		const result: Array<{
			type: RewardType;
			ids: string[];
			rarity?: CaseItemRarity;
		}> = [];

		const clothesGroup: { ids: string[]; rarity?: CaseItemRarity } = {
			ids: [],
			rarity: undefined,
		};

		for (const item of lootbox.items) {
			const reward = this.getRewardById(item.donateItemId);

			if (
				reward.type === RewardType.ITEM &&
				item.donateItemId.includes('ccl_')
			) {
				clothesGroup.ids.push(item.donateItemId);
				if (!clothesGroup.rarity && item.rarity) {
					clothesGroup.rarity = item.rarity;
				}
			} else {
				result.push({
					type: reward.type,
					ids: [item.donateItemId],
					rarity: item.rarity,
				});
			}
		}

		if (clothesGroup.ids.length > 0) {
			result.push({
				type: RewardType.ITEM,
				ids: clothesGroup.ids,
				rarity: clothesGroup.rarity,
			});
		}

		const rarityOrder: Record<CaseItemRarity, number> = {
			[CaseItemRarity.LEGENDARY]: 0,
			[CaseItemRarity.EPIC]: 1,
			[CaseItemRarity.RARE]: 2,
			[CaseItemRarity.UNCOMMON]: 3,
			[CaseItemRarity.COMMON]: 4,
		};

		result.sort((a, b) => {
			const rarityA = rarityOrder[a.rarity || CaseItemRarity.COMMON];
			const rarityB = rarityOrder[b.rarity || CaseItemRarity.COMMON];
			return rarityA - rarityB;
		});

		return result;
	}

	getCaseFeed(): Subject<ICaseFeedItem[]> {
		return this.caseFeed;
	}
}
